<script setup>
import axios from "axios";
import {listenForPrivateUserEvent, events} from '@/composables/sockets/sockets'
import {successToast} from "@/composables/useToasts";

const props = defineProps({
  userId: {
    type: Number,
    required: true,
  }
})

const channel = listenForPrivateUserEvent(props.userId, events.SOCKET_TEST, (e) => {
  successToast(e.message);
})


successToast(`Listening to channel ${channel.subscription.name}`);

const trigger = () => {
  axios.get('/preview/sockets/trigger');
}
</script>

<template>
  <div class="tw-text-grey-dark tw-text-lg tw-pb-3">
    Sockets Test
  </div>
  <div class="tw-flex tw-gap-2">
    <button
      type="button"
      class="tw-rounded-md tw-bg-indigo-600 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white"
      @click="trigger"
    >
      Trigger broadcast event
    </button>
  </div>
</template>
